/* Menu drawer cleanup
 * Fixes:
 * 1. Mobile menu drawer doesn't close when user clicks a link inside it
 * 2. After navigation, drawer state (open class, prevent-scroll) can persist via bfcache
 *
 * The theme's mega-menu.js only listens for clicks on the hamburger button and backdrop,
 * not on actual menu links. When the user clicks "Collections", the browser navigates,
 * but the drawer's open state can persist (especially with bfcache).
 */
(function () {
  'use strict';

  function closeMenuDrawer() {
    var drawer = document.getElementById('m-menu-drawer');
    var hamburger = document.querySelector('.m-hamburger-box');
    var menu = document.querySelector('.m-menu-mobile');

    if (drawer) drawer.classList.remove('open');
    if (hamburger) hamburger.classList.remove('active');
    if (menu) {
      menu.classList.remove('m-submenu-open', 'm-submenu-open--level-1', 'm-submenu-open--level-2');
    }
    document.querySelectorAll('.m-megamenu-mobile.open').forEach(function (el) {
      el.classList.remove('open');
    });
    var content = document.querySelector('.m-menu-drawer__content');
    if (content) content.classList.remove('open-submenu');
    document.documentElement.classList.remove('prevent-scroll');
  }

  // 1) Close drawer when user clicks any internal link inside it
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href]');
    if (!link) return;
    var inDrawer = link.closest('#m-menu-drawer');
    if (!inDrawer) return;
    var href = link.getAttribute('href');
    if (!href || href === '#' || href.startsWith('#')) return;
    if (href.startsWith('javascript:')) return;
    // Skip submenu toggles (they have data-toggle-submenu)
    if (link.hasAttribute('data-toggle-submenu')) return;
    // It's a real navigation link — close the drawer state immediately so
    // it's not stuck open when the user comes back via bfcache.
    closeMenuDrawer();
  }, true);

  // 2) Close drawer state on bfcache restore (page may have been left with drawer open)
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      closeMenuDrawer();
    }
  });

  // 3) Close drawer state on initial DOMContentLoaded (defensive — covers edge cases
  // where the previous page somehow left the state behind in the HTML cache)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      // Only clean up if drawer is open AND hamburger isn't (state inconsistency)
      var drawer = document.getElementById('m-menu-drawer');
      var hamburger = document.querySelector('.m-hamburger-box');
      if (drawer && drawer.classList.contains('open') && hamburger && !hamburger.classList.contains('active')) {
        closeMenuDrawer();
      }
    });
  }

  // Expose for debugging
  window.__closeMenuDrawer = closeMenuDrawer;
})();
